import { Link } from '@tanstack/react-router'
import { Euro, FileText, UserPlus } from 'lucide-react'
import * as React from 'react'
import { useState } from 'react'

import { AddOperatorDialog } from '@/components/dashboard/add-operator-dialog'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const linkActions = [
  { label: 'Manage Prices', to: '/products' as const, icon: Euro },
  { label: 'View Invoices', to: '/invoices' as const, icon: FileText },
]

export function DashboardQuickActions({ className }: { className?: string }): React.ReactElement {
  const [addOperatorOpen, setAddOperatorOpen] = useState(false)

  return (
    <div className={cn('bg-muted/50 space-y-3 rounded-xl p-5', className)}>
      <h2 className="text-lg font-extrabold tracking-tight">Quick Actions</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Button
          variant="outline"
          className="bg-background h-auto gap-4 px-6 py-4 text-base font-semibold"
          onClick={() => setAddOperatorOpen(true)}
        >
          <UserPlus className="size-5 shrink-0" />
          Add Operator
        </Button>

        {linkActions.map((action) => (
          <Button
            key={action.label}
            variant="outline"
            className="bg-background h-auto gap-4 px-6 py-4 text-base font-semibold"
            asChild
          >
            <Link to={action.to}>
              <action.icon className="size-5 shrink-0" />
              {action.label}
            </Link>
          </Button>
        ))}
      </div>

      <AddOperatorDialog open={addOperatorOpen} onOpenChange={setAddOperatorOpen} />
    </div>
  )
}
